import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { RouterModule } from '@angular/router';
import { LoginModule } from './login/login.module';
import { FormsModule } from '@angular/forms';
import { GenericModule } from './generic/generic.module';
import { AlertServiceModule } from '@dekra/alert-service-lib';
import { HasAnyAuthorityDirective } from './directives/has-any-authority.directive';
import { NotificationMenuComponent } from './notifications/components/notification-menu/notification-menu.component';
import { DefaultNullValueDirective } from './directives/null-default-value.directive';
import { CallbackSamlModule } from './callback-saml/callback-saml.module';

@NgModule({
  declarations: [HasAnyAuthorityDirective, NotificationMenuComponent, DefaultNullValueDirective],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
    LoginModule,
    GenericModule,
    AlertServiceModule,
    CallbackSamlModule

  ],
  exports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
    LoginModule,
    GenericModule,
    HasAnyAuthorityDirective,
    AlertServiceModule,
    NotificationMenuComponent,
    DefaultNullValueDirective,
    CallbackSamlModule
  ]
})
export class SharedModule {}
